import { skipsRentalDays } from './rentalDays';

const firstPresent = (...values) =>
  values.find(value => value !== undefined && value !== null && value !== '');

// Quotes use saved values, never current catalog prices or form drafts.
export const quoteInvoiceItems = payload => {
  const items = payload?.invoice_items;
  if (!Array.isArray(items)) return [];

  return items
    .filter(item => item && typeof item === 'object' && !Array.isArray(item))
    .map(item => {
      const quantity = Math.max(Number(item.quantity) || 1, 1);
      const savedUnitPrice = firstPresent(item.unit_price, item.unitPrice);
      const savedTotal = firstPresent(item.total);
      const unitPrice = Number(
        savedUnitPrice ?? (savedTotal === undefined ? 0 : savedTotal / quantity)
      );
      return {
        product_type: item.product_type || item.productType || '',
        product_id: item.product_id ?? item.productId ?? null,
        product_name: item.product_name || item.productName || 'Item',
        quantity,
        unit_price: unitPrice,
        total: Number(savedTotal ?? quantity * unitPrice),
        ...(skipsRentalDays(item) ? { skip_rental_days: true } : {}),
      };
    });
};

export const contractQuoteInvoiceItems = contract => {
  const items = firstPresent(
    contract.invoice_items,
    contract.invoiceItems,
    contract.metadata?.invoice_items,
    contract.metadata?.invoiceItems
  );
  const persistedItems = quoteInvoiceItems({ invoice_items: items });
  if (persistedItems.length) return persistedItems;

  // Legacy contracts may have one product and an aggregate total only.
  if (!contract.product_name) return [];
  return quoteInvoiceItems({
    invoice_items: [
      {
        product_type: contract.product_type,
        product_id: contract.product_id,
        product_name: contract.product_name,
        quantity: 1,
        total: firstPresent(
          contract.invoice_total,
          contract.invoiceTotal,
          contract.metadata?.invoice_total,
          contract.metadata?.invoiceTotal,
          0
        ),
      },
    ],
  });
};

// Quick quotes use CustomService; contracts persist TalkviaCustomService.
export const quoteContractItems = items =>
  (items || []).map(item => ({
    ...item,
    product_type:
      item.product_type === 'CustomService'
        ? 'TalkviaCustomService'
        : item.product_type,
  }));
